{
  "blocks": [
    {
      "id": "test-afc",
      "kind": "test",
      "tags": ["afc", "testing", "her", "clinic-visit", "pre-cycle"],
      "title": "Antral Follicle Count (AFC)",
      "subtitle": "Ultrasound count of resting follicles, a key ovarian reserve marker",
      "icon": "🔬",
      "body": {
        "testName": "Antral Follicle Count (AFC)",
        "category": "monitoring",
        "whatItMeasures": "Counts the small resting follicles (2-10 mm) visible on each ovary via ultrasound. Along with AMH, it is one of the two most important ovarian reserve markers. A higher count suggests more eggs are available for stimulation.",
        "howItWorks": "A transvaginal ultrasound performed on cycle day 2-4. The sonographer counts all visible antral follicles on both ovaries. Each follicle potentially contains an egg that could respond to stimulation medications. The count helps predict how many eggs might be retrieved during IVF and guides medication dosing. The same scan may also notice cysts, fibroids, or polyps, although dedicated imaging may be needed if the clinic needs a closer look.",
        "quickFacts": [
          {
            "kind": "sample",
            "value": "Transvaginal ultrasound"
          },
          {
            "kind": "time",
            "value": "5-10 min scan"
          },
          {
            "kind": "pain",
            "value": "Pressure, usually mild"
          },
          {
            "kind": "prep",
            "value": "Cycle day 2-4"
          },
          {
            "kind": "results",
            "value": "During the appointment"
          }
        ],
        "turnaroundTime": "Immediate: results during the ultrasound appointment",
        "costRange": {
          "low": 200,
          "high": 500
        },
        "atHome": false,
        "clinicRequired": true,
        "cycleDay": "Day 2-4",
        "whyItMatters": [
          "AFC is useful as a baseline ovarian reserve marker and for planning stimulation dose.",
          "It can vary by about 2-5 follicles from cycle to cycle, so one count should be interpreted with AMH, age, and the full clinical picture.",
          "It is not usually treated as a short-term optimization metric in the same way as vitamin D, TSH, or metabolic markers."
        ],
        "dataPoints": ["dp-follicle-count"],
        "section": "ovarian-reserve"
      },
      "sources": [
        {
          "title": "ESHRE guideline: ovarian stimulation for IVF/ICSI",
          "authors": "ESHRE Guideline Group on Ovarian Stimulation (Bosch E, Broer S, Griesinger G, Broekmans F, et al.)",
          "journal": "Human Reproduction Open",
          "year": 2020,
          "url": "https://academic.oup.com/hropen/article/2020/2/hoaa009/5826933",
          "evidenceLevel": "guideline"
        },
        {
          "title": "ESHRE consensus on the definition of 'poor response' to ovarian stimulation for in vitro fertilization: the Bologna criteria",
          "authors": "Ferraretti AP, La Marca A, Fauser BCJM, Tarlatzis B, Nargund G, Gianaroli L",
          "journal": "Human Reproduction",
          "year": 2011,
          "url": "https://academic.oup.com/humrep/article/26/7/1616/640052",
          "evidenceLevel": "guideline"
        }
      ],
      "readTimeMinutes": 3
    }
  ],
  "relationships": [],
  "localeVariants": []
}
